import { ELEMENT__STATIC_TYPES } from '../redux/constants';

export const isStaticElementType = (type) => ELEMENT__STATIC_TYPES.includes(type);
